import React, { Fragment } from "react";
import { Checkbox, FormHelperText } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { connect, FastField } from "formik";
import _ from "lodash";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import inputComponentMask from "lib/inputMask";

const styles = theme => ({
  labelRoot: {
    fontSize: "17px"
  },
  inputField: {
    borderBottom: "1px solid #2196F3"

  },
  error: {
    "& input": {
      borderBottom: "1px solid red"
    }
  }
});

const IntegerInput = ({ label, fieldName, classes, ...otherProps }) => (
  <FastField
    name={fieldName}
    render={({ field, form }) => {
      const { touched, errors } = form;
      const fieldError = _.get(errors, fieldName);
      const fieldTouched = _.get(touched, fieldName);

      return (
        <>
          <Checkbox
            label={label || ""}
            name={fieldName}
            value={field.value}
            onChange={field.onChange}
            InputLabelProps={{
              FormLabelClasses: {
                root: classes.labelRoot
              }
            }}
            InputProps={{
              classes: {
                input: classes.inputField
              },
              disableUnderline: true
            }}
            {...otherProps}
          />
          {Boolean(fieldError) && <FormHelperText>{fieldError}</FormHelperText>}
        </>
      );
    }}
  />
);
export default compose(
  withStyles(styles)
)(IntegerInput);
